import { Divider, Stack, Typography } from "@mui/material";
import { CardProps } from ".";
import { DadoValorPrinter } from "../../../../../components/BasicComponents/DisplayDados/DadoValorPrinter";
import LabelPrinter from "../../../../../components/LabelPrinter";
import { PaperBox } from "../../../../../components/Layout/PaperBox";
import FazendaSection from "../../MIPedidos/DialogCriarPedidoVenda/CriarPedido/ClienteCard/FazendaSection";

export default function CardResumo({
    data
}: PropsCardResumo) {
    return (
        <PaperBox>
            <LabelPrinter
                titulo="Código"
                valor={`#${data.codigo}`}
            />
            {data.cancelado_por && data.cancelado &&
                <Stack>
                    <Typography fontWeight="bold" color="error" variant="subtitle2">Pedido cancelado por</Typography>
                    <Typography fontWeight="bold" variant="subtitle2" color="error">{data.cancelado_por}</Typography>
                </Stack>
            }
            <DadoValorPrinter
                titulo="Data de criação"
                valor={`${data.data_criacao}`}
            />

            <DadoValorPrinter
                titulo="Loja de origem"
                valor={`${data.loja_faturamento.id} - ${data.loja_faturamento.nome}`}
            />

            <DadoValorPrinter
                titulo="Público"
                valor={`${data.tipo_publico}${data.codigo_publico} - ${data.publico.nome_pessoa}`}
            />
            <DadoValorPrinter
                titulo="Comprador"
                valor={`${data.comprador}`}
            />
            <DadoValorPrinter
                titulo="Vendedor"
                valor={`${data.vendedor.nome}`}
            />
            <DadoValorPrinter
                titulo="Consultor"
                valor={`${data.consultor ? data.consultor.nome : "-"}`}
            />

            <Divider sx={{ my: 2 }} />

            <FazendaSection fazenda={data.fazenda} />
        </PaperBox>
    )
}

interface PropsCardResumo extends CardProps { }
